const en = {
  // Navbar
  nav: {
    generate: "Generate",
  },
  // Sidebar
  sidebar: {
    dashboard: "Dashboard",
    generate: "Generate",
    history: "History",
    templates: "Templates",
    account: "Account",
    profile: "Profile & voice",
    billing: "Billing",
    credits: "Credits",
    renewsOn: "Renews {{date}}",
    voice: "Voice",
    favorites: "Favorites",
    settings: "Settings",
    logout: "Log out",
    expand: "Expand menu",
    collapse: "Collapse menu",
  },
  // Dashboard
  dashboard: {
    eyebrow: "Dashboard",
    greeting: "Hello {{name}}.",
    tagline: "What are we creating?",
    historyBtn: "History",
    newContent: "New content",
    emptyTitle: "Welcome to CONTENT.IQ!",
    emptyDesc: "Generate your first content to see your statistics.",
    emptyBtn: "Generate my first content",
    creditsRemaining: "Credits remaining",
    renewsIn: "Renews in {{days}} days",
    topUp: "Top up",
    contentsThisMonth: "Contents this month",
    thisMonth: "+{{n}} this month",
    tokensUsed: "Tokens used",
    totalCumul: "total cumulative",
    favorites: "Favorites",
    savedContents: "saved contents",
    activityChart: "Activity — 30 days",
    activityChartBase: "Activity",
    topTypes: "Most used types",
    recentContents: "Recent contents",
    seeAll: "See all →",
    noHistory: "Generate content to see history",
    overview: "Overview",
    totalCreated: "total contents created",
    creditsUsedMonth: "credits used this month",
    generateBtn: "Generate",
    noData: "No data yet",
    today: "Today",
    period30d: "30d",
    period7d: "7d",
    periodYear: "yr",
  },
  // Generate page
  generate: {
    title: "New content",
    briefHeader: "Generation brief",
    dictate: "Dictate brief",
    contentType: "Content type",
    subject: "Subject *",
    subjectPlaceholder: "E.g. Announcing our Business plan for African agencies",
    tone: "Tone",
    length: "Length",
    language: "Language",
    keywords: "Keywords to include",
    keywordPlaceholder: "+ add…",
    audience: "Target audience",
    audiencePlaceholder: "E.g. African SMEs, 30-50 years old",
    generateBtn: "Generate content",
    generatingBtn: "Generating…",
    stopBtn: "Stop",
    hint: '⌘ + ↵ or say "generate"',
    statusGenerating: "● Generating",
    statusReady: "✓ Content ready",
    statusConfigure: "Configure and generate",
    tokens: "{{n}} tokens…",
    copy: "Copy",
    copied: "Copied!",
    regenerate: "Regenerate",
    exporting: "Exporting…",
    export: "Export",
    exportPdf: "PDF",
    exportDocx: "Word (.docx)",
    exportMarkdown: "Markdown",
    exportTxt: "Text (.txt)",
    exportSuccess: "{{fmt}} export ready!",
    exportError: "Export failed",
    exportErrorDesc: "Check your plan or try again.",
    briefDictated: "Brief dictated!",
    briefDictatedDesc: "The subject has been filled in automatically.",
    // Content types
    typeLinkedin: "LinkedIn",
    typeBlog: "Article",
    typeEmail: "Email",
    typeTwitter: "X / Thread",
    typeInstagram: "Instagram",
    typeProduct: "Product",
    typeYoutube: "YouTube",
    typeBio: "Bio",
    // Tones
    toneProfessional: "Professional",
    toneCasual: "Casual",
    toneInspiring: "Inspiring",
    toneTechnical: "Technical",
    toneHumorous: "Humorous",
    tonePersuasive: "Persuasive",
    // Lengths
    lengthShort: "Short · < 300 words",
    lengthMedium: "Medium · 300–800 words",
    lengthLong: "Long · 800–2000 words",
    // TTS
    ttsRead: "Read",
    ttsStop: "Stop",
    // Translation
    translate: "Translate FR",
    translating: "Translating…",
    translateNeedSave: "Save content first",
    translateDone: "Translation ready!",
    translateError: "Translation error",
    translationTitle: "French translation",
    // Toasts
    contentGenerated: "Content generated!",
    contentNotFound: "Content not found",
    genSaveError: "Save error",
    templateSaved: 'Template "{{name}}" saved',
    templateSaveError: "Error saving template",
    streamingError: "Generation error",
  },
  // Voice page
  voice: {
    pageTitle: "Voice assistant",
    pageSubtitle: "Speak to navigate, generate, or read content.",
    tapToSpeak: "Tap the mic to speak",
    listening: "Listening… Speak now",
    processing: "Processing…",
    transcriptLabel: "Transcript",
    copyTranscript: "Copy",
    detectedCommand: "Detected command",
    commandsTitle: "Command examples",
    ttsActive: "Reading aloud…",
    ttsStop: "Stop",
    exNav: "Dashboard",
    exNavDesc: "Navigate to a page",
    exGenerate: "Generate a LinkedIn post about AI",
    exGenerateDesc: "Opens the generate page pre-filled",
    exRead: "Read the content",
    exReadDesc: "Starts TTS reading of current content",
    exTranslate: "Translate to French",
    exTranslateDesc: "Starts translation of the content",
    exExport: "Export as PDF",
    exExportDesc: "Starts export in desired format",
    exHelp: "Help",
    exHelpDesc: "Shows available commands list",
    assistantTitle: "IQ Vocal",
    assistantListen: "Listening…",
    assistantProcessing: "Processing…",
    assistantClose: "Close",
    assistantContextNeeded: "Open a content first for this command.",
    assistantUnknown: "Command not recognized",
    wakeWordLabel: "Wake word",
    wakeWordDesc: "Say this word to automatically activate the voice assistant.",
    wakeWordCustom: "Custom word…",
    wakeWordSave: "Save",
    wakeWordSaved: "Wake word saved: {{word}}",
    wakeWordTooShort: "The word must be at least 2 characters.",
    wakeWordActive: "Active word: “{{word}}”",
    transcriptionCopied: "Transcription copied!",
    processingError: "Processing error",
    unsupportedTitle: "Voice input unavailable",
    unsupportedHint:
      "Your browser doesn't support speech recognition. Try Chrome on Android or a desktop browser (Chrome / Edge). Voice input isn't available on iPhone/iPad.",
    unsupportedClose: "Close",
    cmdNavigate: "Opening the requested page.",
    cmdGenerating: "Starting generation on: {{subject}}.",
    cmdGenerateOpen: "Opening content generation.",
    cmdNoContent: "No content to work with yet. Ask me to generate one.",
    cmdCopied: "Content copied to clipboard.",
    cmdStopped: "Playback stopped.",
    cmdOpenForEdit: "Opening the content to apply your change.",
    cmdNotUnderstood: "Sorry, I didn't catch that. Could you rephrase?",
    cmdScope:
      "I'm IQ Assistant, your voice assistant. I can generate, read, copy, improve, translate or export content. What would you like to create?",
  },
  // History page
  history: {
    title: "History",
    exportBulk: "Export ZIP",
    exportZipDone: "ZIP downloaded!",
    exportZipEmpty: "No visible content to export.",
    tag: "Tags",
    tagAdd: "Add a tag…",
    tagSaved: "Tags updated",
    tagFilterLabel: "Filter by tag",
    tagFilterPlaceholder: "Tag…",
    tagClearFilter: "Clear tag filter",
    searchPlaceholder: "Search all my content… ⌘K",
    allTypes: "All types",
    favorites: "Favorites",
    list: "List",
    grid: "Grid",
    colContent: "Content",
    colType: "Type",
    colTone: "Tone",
    colLang: "Lang",
    colTokens: "Tokens",
    colWhen: "When",
    noResultTitle: "No results",
    noFavoriteTitle: "No favorites",
    emptyTitle: "Library empty",
    noResultDesc: 'No content matches "{{q}}". Try other keywords.',
    noFavoriteDesc: "Mark your favorite content with ★ to find it here.",
    emptyDesc: "Your library is empty. Generate your first content to see it appear here.",
    generateFirst: "Generate my first content",
    resetFilters: "Reset filters",
    totalContents: "{{n}} contents total",
    deleteSuccess: "Content archived",
    copied: "Copied!",
    exportFormatDone: "{{format}} export downloaded!",
    exportFormatError: "Export error",
  },
  // Profile page
  profile: {
    title: "Profile & voice preferences",
    subtitle: "Configure your identity, voice and microphone.",
    accountSection: "Account",
    labelName: "Name",
    labelEmail: "Email",
    labelBio: "Short bio",
    bioPh: "Copywriter & consultant",
    labelLang: "Interface language",
    saveBtn: "Save",
    savingBtn: "Saving…",
    logoutBtn: "Log out",
    saveSuccess: "Profile updated",
    saveError: "Unable to save.",
    voiceSection: "IQ Assistant voice",
    voiceDesc: "Choose the voice that will answer your questions. Click to hear a sample.",
    stopPreview: "Stop",
    listenPreview: "Listen to a preview",
    speedLabel: "Playback speed",
    autoPlayLabel: "Auto-play responses",
    autoPlayDesc: "The assistant reads its responses aloud.",
    micSection: "Microphone & recognition",
    micLangLabel: "Recognition language",
    micEngineLabel: "Main engine",
    micSensLabel: "Mic sensitivity",
    micMoreSensitive: "More sensitive",
    micLiveTest: "Live test",
    micMoreTolerant: "More noise tolerant",
    testMicBtn: "Test my mic",
    testMicSample: "Hello, this is a test…",
    subSection: "Subscription",
    subFree: "Free",
    subPro: "$9.99 / month",
    subBusiness: "$29.99 / month",
    stripePortal: "Stripe Portal",
    upgradePro: "Go Pro",
    upgradeBusiness: "Go Business",
    upgradeBtn: "Upgrade",
    manageSub: "Manage",
    editProfileTitle: "Edit profile",
    voiceSectionMobile: "Voice preferences",
    voiceAssistantLabel: "Assistant voice",
    listenBtn: "Listen",
    testMicTitle: "Test your microphone",
    micTestingStatus: "Input level detected · OK",
    micTestIdle: "Click to test",
    subAccountSection: "Account & subscription",
    topupCredits: "Top up credits",
    topupDesc: "$10 / 100 cr. · {{remaining}} remaining",
    micLangSetting: "Mic language",
    sensAuto: "Auto",
    sensHigh: "High",
    sensNormal: "Normal",
    sensLow: "Low",
    voiceSaved: 'Voice "{{name}}" saved',
  },
  // Templates page
  templates: {
    title: "Templates",
    createBtn: "Create a template",
    countDesc: "{{n}} templates available · share yours with your team.",
    searchPh: "Search for a template…",
    myTemplates: "My templates",
    catAll: "All",
    catMarketing: "Marketing",
    catSocial: "Social",
    catBusiness: "Business",
    catCreative: "Creative",
    upgradePlanNotice: "Custom template creation is available from the",
    noDescr: "No description",
    usageCount: "↗ {{n}} uses",
    useBtn: "Use →",
    deleteTitle: "Delete",
    noResultTitle: "No template found",
    noResultDesc: 'No template matches "{{q}}". Try another term.',
    emptyCatTitle: "No templates available",
    emptyCatDesc: 'No templates in the "{{cat}}" category.',
    emptyDesc: "Templates will be available after database initialization.",
    seeAll: "See all templates",
    createFirst: "Create my first template",
    loaded: 'Template "{{name}}" loaded!',
    deleted: "Template deleted",
    // Create modal
    modalTitle: "New template",
    labelName: "Name *",
    namePh: "E.g. Viral LinkedIn post",
    labelDesc: "Description",
    descPh: "Short description",
    labelType: "Type",
    labelCategory: "Category",
    catSocialOption: "Social networks",
    labelPrompt: "Template prompt *",
    promptHint: "(use {{variable}} for variables)",
    promptPh: "Generate a LinkedIn post about {{topic}} with a {{tone}} tone.",
    makePublic: "Make this template public",
    cancelBtn: "Cancel",
    createModalBtn: "Create template",
    creatingBtn: "Creating…",
    createdSuccess: "Template created!",
    createError: "Error creating template",
  },
  // Pricing page
  pricing: {
    eyebrow: "Simple pricing",
    title: "Choose your voice.",
    subtitle: "Monthly or annual — 2 months free. Cancel anytime from the Stripe portal.",
    monthly: "Monthly",
    annual: "Annual · −20%",
    manageBtn: "Manage subscription",
    loadingBtn: "Loading…",
    perMonthAnnual: "/month (annual)",
    perMonth: "/month",
    currentPlan: "Current plan",
    payError: "Unable to open payment. Please try again.",
    portalError: "Billing portal unavailable.",
    creditsALaCarte: "Credits à la carte:",
    creditPrice: "$10 / 100 cr.",
    creditDesc: "1 credit ≈ 350 words generated.",
    freeTag: "To discover",
    freeCta: "Get started",
    proTag: "Most popular",
    proCta: "Choose Pro",
    businessTag: "Agencies & teams",
    businessCta: "Choose Business",
  },
  // Auth page
  verifyEmail: {
    loadingTitle: "Verifying…",
    loadingDesc: "Validating your email address.",
    successTitle: "Email verified!",
    successDesc: "Your account is active. Happy generating!",
    successCta: "Go to my workspace",
    errorTitle: "Invalid link",
    errorDesc: "This link is invalid or has expired (24h). Request a new one from the login page.",
    backLogin: "← Back to login",
  },
  resetPassword: {
    successTitle: "Password reset!",
    successDesc: "Redirecting to login in a few seconds…",
    successCta: "Sign in now",
    title: "New password",
    subtitle: "Choose a secure password for your account.",
    labelNew: "New password",
    labelNewHint: "· min. 8 characters",
    labelConfirm: "Confirm password",
    submit: "Reset my password",
    submitting: "Resetting…",
    backLogin: "← Back to login",
    invalidLink: "Invalid or expired link",
    strengthWeak: "Weak",
    strengthOk: "Fair",
    strengthSolid: "Solid",
    strengthStrong: "Strong",
  },
  admin: {
    title: "Administration",
    subtitle: "User management, statistics and logs",
    tabUsers: "Users",
    tabLogs: "Logs",
    loading: "Loading…",
    roleUpdated: "Role updated",
    error: "Error",
    banned: "User banned",
    bannedDesc: "Sessions revoked, role reset to Free.",
    statUsers: "Total users",
    statUsersSub: "+{{count}} this week",
    statContents: "Generated content",
    statCredits: "Credits consumed",
    statCreditsSub: "cumulative total",
    statPlans: "Plan breakdown",
    statQuality: "Average quality score",
    statQualitySub: "{{count}} content evaluated",
    searchPh: "Search by name or email...",
    allRoles: "All roles",
    colUser: "User",
    colRole: "Role",
    colCredits: "Credits",
    colJoined: "Joined",
    colActions: "Actions",
    noUsers: "No users found",
    emailUnverified: "Email not verified",
    ban: "Ban",
    pagination: "{{total}} users · Page {{page}}/{{pages}}",
    banTitle: "Ban this user?",
    banIrreversible: "This action is irreversible from the UI.",
    banWarning: "All sessions will be revoked, the role reset to Free and credits zeroed.",
    cancel: "Cancel",
    banConfirm: "Confirm ban",
    liveTitle: "Live activity",
    liveWaiting: "Waiting for events (signups, generations)…",
    liveSignup: "Signup",
    liveGeneration: "Generation",
  },
  logs: {
    title: "Activity logs",
    meta: "{{total}} entries · auto-deleted after 90 days",
    loading: "Loading…",
    autoOn: "Auto ON",
    autoOff: "Auto OFF",
    refresh: "Refresh",
    clear: "Clear",
    clearConfirm: "Delete all logs?",
    cleared: "{{count}} logs deleted",
    allLevels: "All levels",
    levelInfo: "Info",
    levelWarn: "Warning",
    levelWarnShort: "Warn",
    levelError: "Error",
    allCats: "All categories",
    catAuth: "Auth",
    catGeneration: "Generation",
    catCredits: "Credits",
    catSystem: "System",
    catAdmin: "Admin",
    colTime: "Timestamp",
    colLevel: "Level",
    colCategory: "Category",
    colAction: "Action",
    colMessage: "Message",
    colUser: "User",
    colIp: "IP",
    noLogs: "No logs found",
    pagination: "Page {{page}} / {{pages}} · {{total}} entries",
  },
  auth: {
    loginTitle: "Welcome back.",
    loginSubtitle: "Sign in to continue your drafts.",
    continueGoogle: "Continue with Google",
    or: "OR",
    orEmail: "OR BY EMAIL",
    labelEmail: "Email",
    emailPh: "you@example.com",
    labelPassword: "Password",
    forgotPwd: "Forgot?",
    loginBtn: "Sign in",
    loggingInBtn: "Signing in…",
    loginFailed: "Sign in failed",
    loginError: "Connection error",
    noAccount: "No account yet?",
    createAccount: "Create an account",
    registerTitle: "Create your account",
    registerSubtitle: "50 credits free. No credit card.",
    labelFullName: "Full name",
    fullNamePh: "Abdel Wariss Osseni",
    labelPasswordStrength: "Password",
    passwordHint: "· min. 8 characters",
    pwdWeak: "Weak",
    pwdOk: "Fair",
    pwdSolid: "Good",
    pwdStrong: "Strong",
    labelYouAre: "You are…",
    contentCreator: "Content creator",
    agency: "Communication agency",
    sme: "SME / Startup",
    freelance: "Freelance",
    ngo: "NGO / Association",
    acceptTerms: "I accept the terms and privacy policy.",
    createBtn: "Create my account",
    creatingBtn: "Creating…",
    registerFailed: "Registration failed",
    registerError: "Registration error",
    alreadyAccount: "Already registered?",
    signIn: "Sign in",
    forgotTitle: "Forgot password",
    forgotSubtitle: "Enter your email to receive a reset link.",
    sendLinkBtn: "Send link",
    sendingBtn: "Sending…",
    sendError: "Unable to send email.",
    backToLogin: "← Back to login",
    emailSentStep: "Step 2 / 3",
    emailSentTitle: "We sent you a link.",
    emailSentDesc: "Email sent to {{email}}. The link expires in 1h.",
    notReceived: "Not received?",
    spamCheck: "Check your spam folder",
    wait30s: "Wait ~30 seconds",
    resendBelow: "Resend the link below",
    resendBtn: "Resend",
    resendTimer: "Resend · 0:{{s}}",
    backToLoginBtn: "Back to login",
    emailResent: "Email resent!",
    resendError: "Error",
    testimonialLabel: "★ Testimonial",
    todayLabel: "Today on CONTENT.IQ",
  },
  // Common
  common: {
    loading: "Loading…",
    error: "An error occurred",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    copyright: "© 2026 CODEXA Solutions — All rights reserved",
  },
  // Landing page
  landing: {
    // Nav
    navProduct: "Product",
    navVoice: "Voice",
    navTemplates: "Templates",
    navPricing: "Pricing",
    navUseCases: "Use cases",
    navLogin: "Sign in",
    navCta: "Free trial",
    // Hero
    heroPill: "New · IQ Voice Assistant",
    heroTitle: "Write out loud.",
    heroTitleAccent: "Not on a keyboard.",
    heroDesc:
      "CONTENT.IQ generates articles, posts, emails and more — in real-time streaming via Claude. Dictate your brief, navigate by voice, chat with the IQ Assistant. Without touching the keyboard.",
    heroCtaPrimary: "Get started · 10 free credits",
    heroCtaDemo: "Voice demo · 0:42",
    trustReviews: "★★★★★ 4.9 · 82 Product Hunt reviews",
    trustNoCc: "No CC required",
    // Built for
    builtForTitle: "Built for",
    builtForCreators: "Content creators",
    builtForAgencies: "Agencies",
    builtForSME: "SMEs",
    builtForNGOs: "NGOs",
    builtForFreelance: "Freelancers",
    builtForMicro: "Microfinance",
    // Pillars
    pillarsTitle: "Three ways to produce.",
    pillarsTitleAccent: "One app.",
    p0tag: "01 · GENERATE",
    p0title: "Streaming generation",
    p0body: "Token by token via SSE. You see the content appear live, like a real conversation.",
    p0meta: "Claude · 12 formats",
    p1tag: "02 · ASSIST",
    p1title: "Context-aware IQ Assistant",
    p1body:
      "It knows your page, your credits, your draft. It improves, suggests, brainstorms with you.",
    p1meta: "20 context turns",
    p2tag: "03 · VOICE",
    p2title: "All by voice",
    p2body:
      "Dictate your brief, navigate by voice, listen to responses. ElevenLabs + Whisper + Web Speech.",
    p2meta: "25 native commands",
    // Voice section
    voiceTag: "03 · VOICE",
    voiceTitle: "Your voice.",
    voiceTitleAccent: "Your tool.",
    voiceDesc:
      "Dictate your brief, navigate between pages, trigger generations — without ever touching the keyboard. ElevenLabs for synthesis, Whisper for transcription, Web Speech for instant reactivity.",
    voiceFeat0label: "Whisper + Web Speech transcription",
    voiceFeat0desc: "Professional accuracy · zero latency",
    voiceFeat1label: "ElevenLabs voice synthesis",
    voiceFeat1desc: "Listen to IQ Assistant responses in audio",
    voiceFeat2label: "25 native commands",
    voiceFeat2desc: "Generate, navigate, export — all by voice",
    voiceCmdsTitle: "Live voice commands",
    // CTA band
    ctaTitle: "Start for free.",
    ctaTitleAccent: "Today.",
    ctaDesc: "10 free credits · No credit card · Cancel anytime",
    ctaBtn: "Create my free account",
    // Footer
    footerLogin: "Sign in",
    footerPrivacy: "Privacy",
    footerTerms: "Terms",
    footerApi: "API",
    footerApiSoon: "Soon",
    // Demo modal
    demoPaused: "Paused",
    demoPlaying: "Playing",
    demoCta: "Try for free",
  },
  // 404 page
  notFound: {
    title: "Page not found",
    desc: "This page doesn't exist or has been moved. Return to your workspace.",
    backDashboard: "Back to Dashboard",
    generate: "Generate content",
    backHome: "Back to home",
    login: "Sign in",
  },
  notify: {
    subscriptionActive: "Subscription activated — your credits have been updated.",
    paymentFailed: "Payment failed. Update it within 3 days to avoid downgrade to Free.",
  },
} as const;

export default en;
